import { Component, OnInit, inject } from '@angular/core';
import { Exam, ExamQuery } from 'src/app/api/models';
import { ExamsService } from 'src/app/api/services';
import { getExamConfig } from 'src/app/cms/exam/cms-exam-select-exam.component';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { EXAM_TOUR_STEPS, showExamTour } from '../../onboarding/exam-tour';
import { TourTrackType } from '../../onboarding/guided-tour';
import { SubscriptionLimit } from 'src/app/cms/common/dialogs/subscription-limit-warning/subscription-limit-warning.component';
import {
  DashboardCardBaseComponent,
  getSteps,
  ProgressBarData,
  ProgressStep,
} from '../dashboard-card-base.component';
import { ListConfig } from 'src/app/cms/list/list.types';
import { QuickFeedbackOverlayService } from 'src/app/cms/common/quick-feedback-overlay/quick-feedback-overlay.service';
import { NgTemplateOutlet } from '@angular/common';
import { ProgressStatusBarComponent } from '../progress-dialog/progress-status-bar/progress-status-bar.component';

@Component({
  selector: 'qa-exam-card',
  templateUrl: './exam-card.component.html',
  styleUrls: ['./exam-card.component.scss'],
  imports: [
    MatCard,
    RouterLink,
    MatIcon,
    ButtonComponent,
    TranslateModule,
    NgTemplateOutlet,
    ProgressStatusBarComponent,
  ],
})
export class ExamCardComponent
  extends DashboardCardBaseComponent<Exam>
  implements OnInit
{
  examConfig: ListConfig<Exam>;
  steps: ProgressStep[];
  progress: ProgressBarData;
  cardType = TourTrackType.EXAM;

  private examsService = inject(ExamsService);
  private feedbackService = inject(QuickFeedbackOverlayService);

  ngOnInit(): void {
    this.examsService
      .queryExams({
        body: {
          filters: {},
          sorting: [
            {
              option: 'created_at',
              direction: 'DESC',
            },
          ],
          paging: {
            page_size: 4,
          },
        } as Partial<ExamQuery> as ExamQuery,
      })
      .subscribe((res) => {
        this.items = res.data;
        this.totalItems = res.pagination.total;
        this.subscriptionLimit.subscriptionLimit.EXAM_COUNT =
          res.pagination.total;
        this.isLoaded = true;
      });

    this.examConfig = getExamConfig(
      this.examsService,
      this.router,
      this.translator,
      this.panelService,
      this.snackBar,
      this.dialog,
      this.userJourney,
      this.editService,
      this.subscriptionLimit,
      this.feedbackService,
      this.matDialog
    );
    const data = getSteps(TourTrackType.EXAM, this.userJourney);
    this.steps = data.steps;
    this.progress = data.progressData;
    this.loadPreferences();
  }

  onProgressClick(event: MouseEvent) {
    event.stopPropagation();
    const data = {
      title: 'dashboardNew.progressSection.examsProgress',
      tourType: TourTrackType.EXAM,
      stepsData: {
        steps: this.steps,
        progressData: this.progress,
      },
    };
    this.openProgressDialog(data);
  }

  openAddContentDialog(event) {
    event.stopPropagation();
    this.openAddContentDialogBase(
      SubscriptionLimit.EXAM_COUNT,
      this.examConfig.wizardImports,
      'content.wizardActions.title.createExam'
    );
  }

  openVideo(event) {
    event.stopPropagation();
    this.openVideoBase(TourTrackType.EXAM, 'exam');
  }

  openStep(event) {
    event.stopPropagation();
    this.openStepBase(
      TourTrackType.EXAM,
      'https://quizacademy.de/akademie/examen/'
    );
  }

  onGuidedTour(event) {
    event.stopPropagation();
    showExamTour(
      this.injector,
      EXAM_TOUR_STEPS.START_TOUR,
      this.items.length ? null : EXAM_TOUR_STEPS.CLICK_ON_ADD
    );
  }
}
